export const columns = [
  {
    title: "材料名称",
    dataIndex: "materialName",
    key: "materialName",
  },
  {
    title: "批次号",
    dataIndex: "batchBizNo",
    key: "batchBizNo",
  },
  {
    title: "库存质量",
    dataIndex: "storageQualityName",
    width:100,
    key: "storageQualityName",
  },
];
